import { Fragment } from 'react';

import { Typography as Text } from '@material-ui/core';

import { extractLastNameComponent } from '@spotify/confidence-core-react';
import {
  ActivityItem,
  DeltaText,
} from '@spotify/plugin-confidence-activity-react';

import { ImageSection } from './ImageSection';
import { PropertiesSection } from './PropertiesSection';
import { Variant } from './types';

export const FlagUpdatesVariantDetails = ({
  oldVariant,
  newVariant,
}: {
  oldVariant?: Variant;
  newVariant?: Variant;
}) => {
  const name = extractLastNameComponent(oldVariant?.name ?? newVariant?.name);

  return (
    <Fragment>
      <ActivityItem.Section label="Name">
        <Text variant="body1">{name}</Text>
      </ActivityItem.Section>
      {(oldVariant?.description || newVariant?.description) && (
        <ActivityItem.Section label="Description">
          {oldVariant && newVariant ? (
            // update variant
            <DeltaText
              variant="body1"
              oldText={oldVariant?.description ?? ''}
              newText={newVariant?.description ?? ''}
            />
          ) : (
            // create or delete variant
            <Text variant="body1">
              {oldVariant?.description ?? newVariant?.description ?? ''}
            </Text>
          )}
        </ActivityItem.Section>
      )}
      <PropertiesSection oldVariant={oldVariant} newVariant={newVariant} />
      <ImageSection oldVariant={oldVariant} newVariant={newVariant} />
    </Fragment>
  );
};
